import React, { Component } from 'react'
import SimpleTabs from './components/OrderRequestTabPanel';

class OrderRequestTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default OrderRequestTab
  